import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { StorageService } from "../storage/storage.service";
import { IOrder } from "src/app/interfaces/Order/Order.interface";

@Injectable({
  providedIn: "root",
})
export class BookingService {
  private API_URL = environment.API_URL;

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  private getToken() {
    let data = this.storageService.get("auth");
    const headers = {
      Authorization: `Bearer ${data?.token}`, // Replace `token` with your actual bearer token
    };
    return headers;
  }

  updateOrder = async (id: string, updates: Partial<IOrder>): Promise<any> => {
    // const orderCollection = collection(this._firestore, FIREBASE_COLLECTIONS.ORDERS);
    // const docRef = doc(orderCollection, id);
    // await updateDoc(docRef, { ...updates });
    // const dataRef = await getDoc(docRef);
    // if (!dataRef.exists()) throw new Error(`Booking with id ${id} not found`);
    // const data = dataRef.data();
    // return data;
  };

  getPlayerBookings(params: any) {
    const authUser = this.storageService.get("auth");
    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.API_URL}/order/player-orders/${authUser.uid}`, params)
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }

  getPlayerPendingBookings(playerId: string | number) {
    const headers = this.getToken();

    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.API_URL}/booking-request/player/${playerId}`, { headers })
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }

  cancelBookingRequest(bookingId: string, params: any) {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.API_URL}/booking-request/cancel/${bookingId}`, params)
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }

  makeBookingRequest(payload: any) {
    const headers = this.getToken();
    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.API_URL}/booking-request`, payload, { headers })
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }

  cancelBooking(bookingId: string, params: any) {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.API_URL}/order/cancel/${bookingId}`, params)
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }
}
